import {txt, type Texto} from '../i18n/idioma';

// Notas (i) de la financiacion con Bluequest (Daniel, 15/10/2026): el
// financiador al crear la exportacion, los documentos Bluequest, los bancos y
// las condiciones del financiador.

export const AYUDA_NUEVA_EXPORTACION = {
  financiador: txt(
    'Quién financia la exportación (BLQ, LC, BC…). Se puede dejar en blanco y elegir después en la financiación. Si es Bluequest, la exportación tendrá los documentos Bluequest.',
    'Who finances the export (BLQ, LC, BC…). It can be left blank and chosen later in the financing. If it is Bluequest, the export will have the Bluequest documents.',
  ),
} satisfies Record<string, Texto>;

export const AYUDA_BLUEQUEST = {
  paquete: txt(
    'Los archivos que pide Bluequest para financiar. Se generan con los datos de esta exportación, sus Big Bags y lo que escribes aquí; quedan guardados con su fecha y quién los pidió. La factura B (balance) todavía no se genera.',
    'The files Bluequest asks for to finance. They are generated with the data of this export, its Big Bags and what you type here; they are saved with their date and who requested them. Invoice B (balance) is not generated yet.',
  ),
  factura: txt(
    'Número de la factura al financiador, por ejemplo NIMBLQ-58. Las primeras letras dicen quién vende (NIM) y a qué financiador (BLQ): la empresa vendedora se busca por esa abreviación en Empresas.',
    'Number of the invoice to the financer, for example NIMBLQ-58. The first letters say who sells (NIM) and to which financer (BLQ): the selling company is looked up by that abbreviation in Companies.',
  ),
  fecha: txt(
    'Fecha de los precios del oro y la plata (QP). Es también la fecha de la factura y la del SOFR que se trae del NY Fed.',
    'Date of the gold and silver prices (QP). It is also the invoice date and the date of the SOFR taken from the NY Fed.',
  ),
  precioOro: txt('Precio fijado del oro en USD por onza troy.', 'Fixed gold price in USD per troy ounce.'),
  precioPlata: txt('Precio fijado de la plata en USD por onza troy.', 'Fixed silver price in USD per troy ounce.'),
  banco: txt(
    'Banco que Bluequest da para esta exportación. Define la comisión inicial y el costo de fondos del TC calculation y sale en el packing list. Los bancos se agregan en Financiadores y cupos.',
    'Bank Bluequest gives for this export. It sets the initial fee and the cost of funds of the TC calculation and shows on the packing list. Banks are added in Financers and credit lines.',
  ),
  lote: txt(
    'Referencia del lote que da Bluequest o el custodio (por ejemplo 26-339).',
    'Lot reference given by Bluequest or the custodian (for example 26-339).',
  ),
  pagoEsperado: txt(
    'Fecha en que se espera el pago de Bluequest (Expected payment date). Desde ella se cuentan los días de financiación hasta 5 días antes de la llegada.',
    'Date Bluequest is expected to pay (Expected payment date). Financing days are counted from it until 5 days before arrival.',
  ),
  sofr: txt(
    'SOFR a 3 meses en porcentaje: el promedio a 90 días que publica el NY Fed (SOFR Averages) en la fecha de los precios. "↻ NY Fed" lo trae solo; también se puede escribir.',
    '3-month SOFR in percent: the 90-day average the NY Fed publishes (SOFR Averages) on the price date. "↻ NY Fed" fetches it; it can also be typed.',
  ),
  fechasEnsayo: txt(
    'Fechas del informe del laboratorio: recepción y ensayo de las muestras y el día en que se emite. Vienen sugeridas con el empaque de la primera y la última bolsa; se pueden cambiar.',
    'Dates of the laboratory report: receipt and assay of the samples and the day it is issued. They are suggested from the packing of the first and last bag; they can be changed.',
  ),
} satisfies Record<string, Texto>;

export const AYUDA_TERMINOS_DE_FINANCIADOR = {
  documentos: txt(
    'Documentos que pide este financiador cuando una exportación se financia con él. "Bluequest" activa el TC calculation, la factura y packing list del vendedor, el packing list del custodio y el certificado de ensayo.',
    'Documents this financer asks for when an export is financed with it. "Bluequest" turns on the TC calculation, the seller invoice and packing list, the custodian packing list and the assay certificate.',
  ),
  porcentaje: txt(
    'Parte del valor que financia, en porcentaje (por ejemplo 90).',
    'Share of the value it finances, in percent (for example 90).',
  ),
  margen: txt(
    'Margen anual del financiador en porcentaje (por ejemplo 2).',
    "Financer's annual margin in percent (for example 2).",
  ),
  cobroDocumentos: txt(
    'Cargo fijo de cobro de documentos por exportación, en USD (Doc Collection).',
    'Fixed document collection fee per export, in USD (Doc Collection).',
  ),
  flete: txt(
    "Flete del custodio por contenedor en USD (Ocean Freight cost BRINK's). Se multiplica por los contenedores: toneladas húmedas ÷ 28, hacia arriba.",
    "Custodian freight per container in USD (Ocean Freight cost BRINK's). It is multiplied by the containers: wet tonnes ÷ 28, rounded up.",
  ),
  bancoNombre: txt('Nombre del banco como sale en el TC calculation.', 'Bank name as it shows in the TC calculation.'),
  bancoPackingList: txt(
    'Nombre del banco como sale en el packing list para el custodio, si es distinto. Vacío = el mismo nombre.',
    'Bank name as it shows in the custodian packing list, if different. Empty = same name.',
  ),
  comisionInicial: txt(
    'Comisión inicial del banco en porcentaje (Initial fee, por ejemplo 0,40).',
    "Bank's initial fee in percent (for example 0.40).",
  ),
  costoDeFondos: txt(
    'Costo de fondos del banco en porcentaje anual (COF, por ejemplo 3,05).',
    "Bank's cost of funds in annual percent (COF, for example 3.05).",
  ),
  tiposDeCredito: txt(
    "Qué tipos de crédito da este banco: carta de crédito (LC), buyer's credit (BC) o cash credit (CC). Todos usan el mismo cupo del banco. Al financiar una exportación con el banco se elige uno de estos.",
    "Which credit types this bank gives: letter of credit (LC), buyer's credit (BC) or cash credit (CC). All use the same bank line. When an export is financed with the bank, one of these is chosen.",
  ),
  codigoNuevo: txt(
    'Código corto del financiador, solo letras y números (por ejemplo ICICI, HDFC, SBI). No se puede cambiar después.',
    'Short code of the financer, letters and numbers only (for example ICICI, HDFC, SBI). It cannot be changed later.',
  ),
  financiadorActivo: txt(
    'Desmarcado, el financiador ya no se ofrece para financiar. Sus financiaciones aparecen en "Por pasar a su banco" para elegir el banco (así se reparten las que decían LC o BC).',
    'Unticked, the financer is no longer offered for financing. Its financings show in "To move to their bank" to choose the bank (this is how the LC or BC ones are split).',
  ),
  bancoCupo: txt(
    'Cupo de este banco en USD. El cupo del financiador es la suma de sus bancos.',
    'Line of this bank in USD. The financer line is the sum of its banks.',
  ),
  porReasignar: txt(
    'Financiaciones que siguen con un financiador inactivo (LC o BC sin banco). Elige el banco que financia y el tipo de crédito; así cuentan en el cupo del banco correcto.',
    'Financings still with an inactive financer (LC or BC without bank). Choose the bank that finances and the credit type; that way they count in the right bank line.',
  ),
  bancoActivo: txt(
    'Si lo desmarcas, el banco no se ofrece para exportaciones nuevas.',
    'If you untick it, the bank is not offered for new exports.',
  ),
} satisfies Record<string, Texto>;
